/**
 * Panel ana sayfası.
 * Süper admin ilk açılışta dashboard'a düşer; bayi dashboard görmediği için
 * şirketler listesinde kalır. Şirketler menüsü / hatırlatma deep-link'leri
 * hâlâ /superadmin üzerindedir.
 */
export const SUPERADMIN_DASHBOARD_PATH = '/superadmin/dashboard';
export const SUPERADMIN_COMPANIES_PATH = '/superadmin';

export function getPanelHomePath(role?: string): string {
  return (role || '').toLowerCase() === 'superadmin'
    ? SUPERADMIN_DASHBOARD_PATH
    : SUPERADMIN_COMPANIES_PATH;
}
